<template>
  <div class="page">
    <the-header />
    <the-sidebar :menu-items="sidebarItems" />
    <main class="main">
      <router-view />

      <footer class="footer">
        <p>© {{ new Date().getFullYear() }} DataDrivenCPC</p>
      </footer>
    </main>
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheSidebar from '@/components/TheSidebar.vue'
import * as types from '@/store/types'

export default {
  name: 'Profile',
  components: {
    TheHeader,
    TheSidebar
  },
  data() {
    return {
      // TODO: Возможно скрытые страницы вернуться в будущем
      fullSidebarItems: [
        // {
        //   index: 'summary',
        //   route: { name: 'summary' },
        //   icon: ['fas', 'poll'],
        //   label: this.$t('c.sidebar.summary'),
        //   canShownForFirstLoginView: true
        // },
        {
          index: 'placements',
          route: { name: 'placements' },
          icon: ['fas', 'align-left'],
          label: this.$t('c.sidebar.placementsList'),
          canShownForFirstLoginView: true
        },
        {
          index: 'black-list',
          route: { name: 'black-list' },
          icon: ['fas', 'ban'],
          label: this.$t('c.sidebar.blackList'),
          canShownForFirstLoginView: false
        },
        {
          index: 'white-list',
          route: { name: 'white-list' },
          icon: ['far', 'check-circle'],
          label: this.$t('c.sidebar.whiteList'),
          canShownForFirstLoginView: false
        },
        // {
        //   index: '2',
        //   icon: ['fas', 'file-alt'],
        //   label: this.$t('c.sidebar.placements'),
        //   subItems: [
        //     {
        //       index: 'placements',
        //       route: { name: 'placements' },
        //       label: this.$t('c.sidebar.placementsList'),
        //       canShownForFirstLoginView: true
        //     },
        //     {
        //       index: 'black-list',
        //       route: { name: 'black-list' },
        //       label: this.$t('c.sidebar.blackList'),
        //       canShownForFirstLoginView: false
        //     },
        //     {
        //       index: 'white-list',
        //       route: { name: 'white-list' },
        //       label: this.$t('c.sidebar.whiteList'),
        //       canShownForFirstLoginView: false
        //     }
        //   ]
        // },
        // {
        //   index: 'keywords',
        //   route: { name: 'keywords' },
        //   icon: ['fas', 'key'],
        //   label: this.$t('c.sidebar.keywords'),
        //   canShownForFirstLoginView: true
        // },
        // {
        //   index: 'ads',
        //   route: { name: 'ads' },
        //   icon: ['fas', 'newspaper'],
        //   label: this.$t('c.sidebar.ads'),
        //   canShownForFirstLoginView: true
        // },
        {
          index: 'action-log',
          route: { name: 'action-log' },
          icon: ['fas', 'book'],
          label: this.$t('c.sidebar.actionLog'),
          canShownForFirstLoginView: false
        },
        {
          index: 'settings',
          route: { name: 'settings' },
          icon: ['fas', 'cog'],
          label: this.$t('c.sidebar.settings'),
          canShownForFirstLoginView: false
        }
      ]
    }
  },
  computed: {
    sidebarItems() {
      const isFirstLoginView = this.$store.state[types.SESSION].model.firstLogin

      if (!isFirstLoginView) return this.fullSidebarItems
      return this.fullSidebarItems.map((item) => {
        if (Array.isArray(item.subItems)) {
          return item.subItems.map(subItem => ({ ...subItem, icon: item.icon }))
        }
        return item
      })
        .flat()
        .filter(item => item.canShownForFirstLoginView)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/scss/_vars.scss";
@import "@/assets/style/scss/_extends.scss";

.main {
  @extend %flex-column;
  justify-content: space-between;
  flex: 1 1 auto;
  position: relative;

  padding: $padding-base * 4;
  margin: $header-height-base 0 0 ($sidebar-width-base + 1);

  box-sizing: border-box;
}

.footer {
  margin: $margin-base * 5 0 0;
  color: $light-gray;

  p {
    margin: 0;
  }
}
</style>

<style>
.page > .el-loading-mask {
  position: fixed;
  z-index: 10000;
}
</style>
